import React from 'react';

import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton, Link as MuiLink, Stack, Tooltip, Typography } from '@mui/material';

import CaseAvatar from './CaseAvatar';

export interface DetailField {
  label: string;
  value: string;
  isLink?: boolean;
  isPerson?: boolean;
  isEditable?: boolean;
}

interface Props {
  fields: Array<DetailField>;
}

const EDIT_UNAVAILABLE_TOOLTIP = 'Editing is available once the case API is connected';

export default function CaseDetailFields({ fields }: Props) {
  return (
    <Stack>
      {fields.map((field) => (
        <Stack
          key={field.label}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ py: 1, minHeight: 56, borderBottom: 1, borderColor: 'divider' }}
        >
          <Box>
            <Typography variant="caption" color="text.secondary" display="block">
              {field.label}
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              {field.isPerson && field.value && <CaseAvatar name={field.value} size={24} />}
              {field.isLink && field.value ? (
                <MuiLink component="span" variant="body2" underline="hover">
                  {field.value}
                </MuiLink>
              ) : (
                <Typography variant="body2">{field.value}</Typography>
              )}
            </Stack>
          </Box>
          {field.isEditable && (
            <Tooltip title={EDIT_UNAVAILABLE_TOOLTIP}>
              <span>
                <IconButton size="small" disabled aria-label={`Edit ${field.label}`}>
                  <EditIcon fontSize="small" />
                </IconButton>
              </span>
            </Tooltip>
          )}
        </Stack>
      ))}
    </Stack>
  );
}
